import React from 'react'
import { TailSpin } from 'react-loader-spinner'

export const LoadingSpinner = ({texto}) => {
  return (
    <div className='row'>
        <div className='col-md-12 text-center'>
        <TailSpin
            height="80"
            width="80"
            color="#005e61"
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{display:'block'}}
            wrapperClass="text-center"
            visible={true}
        />
        <h4 className='mt-4'>{texto}</h4>
        </div>
    </div>
    
  )
}
